<template>
  <div style="height:100vh;display:flex;align-items:center;justify-content:center;">
    <div>
      <i class="fa fa-exclamation-triangle " style="font-size: 200px;"></i>
      <h1 style="text-align: center;">页面走丢了!!!!</h1>
      <div style="display:flex;justify-content:space-evenly">
        <div @click="back" style="text-align: center;font-size: 16px;cursor: pointer;padding-top: 20px;text-decoration:underline">上一页</div>
        <div @click="home" style="text-align: center;font-size: 16px;cursor: pointer;padding-top: 20px;text-decoration:underline">首页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    home() {
      //通往首页
      this.$router.push({
        path: "/",
      })
    },
  },
}
</script>

<style>
</style>